import React, { createElement } from 'react';
import { Button } from '@mantine/core';
import classes from './AfaButton.module.css';

interface AfaButtonProps {
  /** Ícono a la izquierda (se pasa el componente directamente) */
  leftIcon?: React.FunctionComponent<any>;
  
  /** Ícono a la derecha (se pasa el componente directamente) */
  rightIcon?: React.FunctionComponent<any>;
  
  /** Tamaño del ícono */
  iconSize?: number;
  
  /** Variant del botón */
  variant?: 'filled' | 'light' | 'outline' | 'subtle' | 'default' | 'gradient';
  
  /** Tamaño del botón */
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  
  /** Radio de bordes */
  radius?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  
  /** Color del botón */
  color?: string;
  
  /** Si está deshabilitado */
  disabled?: boolean;
  
  /** Función onClick */
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  
  /** Contenido del botón */
  children?: React.ReactNode;
  
  /** Clase CSS adicional */
  className?: string;
  
  /** Estilos inline */
  style?: React.CSSProperties;
  
  /** Props HTML adicionales */
  [key: string]: any;
}

/**
 * Wrapper del Button de Mantine con defaults de AFA y soporte simplificado para íconos
 */
export default function AfaButton({
  leftIcon,
  rightIcon,
  iconSize = 16,
  variant = 'filled',
  size = 'sm',
  radius = 'md',
  ...props
}: AfaButtonProps) {
  // Renderizar íconos si se proporcionan
  const leftSection = leftIcon ? createElement(leftIcon, { size: iconSize }) : undefined;
  const rightSection = rightIcon ? createElement(rightIcon, { size: iconSize }) : undefined;

  return (
    <Button
      leftSection={leftSection}
      rightSection={rightSection}
      variant={variant}
      size={size}
      radius={radius}
      color="brand"
      {...(variant === 'outline' && { classNames: { root: classes.outlineRoot } })}
      {...props}
    />
  );
}